import { array, constant, Decoder, number, object, string, union } from '@mojotech/json-type-validation'

import { programLanguageTypeDecoder } from '../language/programLanguageTypeDecoder'

import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { ReviewEntryDetail } from '@/domain/entities/review/reviewEntryDetail'
import { convertJudgeStatusType } from '@/domain/value_objects/judge/JudgeStatusType'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ReviewInstruction } from '@/domain/value_objects/review/ReviewInstruction'

const ReviewInstructionDecoder: Decoder<ReviewInstruction> = union(
  constant('passive'),
  constant('active'),
  constant(null)
)

const DisplayLanguageDecoder: Decoder<DisplayLanguageType> = string().map(x =>
  x === 'ja' || x === 'Japanese' || x === 'JAPANESE' || x === 'jp' ? 'Japanese' : 'English'
)

export const ReviewEntryDecoder: Decoder<ReviewEntry> = object({
  entryId: string(),
  judgeId: number(),
  entryDate: number().map(x => new Date(x)),
  status: string().map(x => convertJudgeStatusType(x)),
  instruction: ReviewInstructionDecoder,
  userId: string(),
  problemId: string(),
  language: programLanguageTypeDecoder,
  displayLanguage: DisplayLanguageDecoder,
  description: string(),
  sourceCode: string(),
  compileError: string(),
  runtimeError: string(),
  closeDate: number().map(x => new Date(x)),
  state: string()
})

export const ReviewEntryListDecoder = array(ReviewEntryDecoder)

const ReviewDetailEntryDecoder: Decoder<ReviewEntryDetail> = object({
  reviewId: string(),
  entryId: string(),
  reviewerId: string(),
  reviewDate: number().map(x => new Date(x)),
  message: string(),
  prompt: string(),
  revisedCode: string()
})

export const ReviewDetailEntryListDecoder = array(ReviewDetailEntryDecoder)
